import React from "react";
import {Edit} from "react-admin";

import PageForm from "./PageForm";

const PageEdit = (props) => (
    <Edit {...props}><PageForm/></Edit>
);

export default PageEdit
